import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleDelete, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Id',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '88%',
    caption: 'Name',
  },
  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '7%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleDelete, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleDelete, translate) => {
  return (
    <DataGridButton
      hint={translate!('Delete', '')}
      icon="remove"
      cellData={cellData}
      onClick={() => handleDelete(cellData)}
    />
  );
};
